const TAG_PATTERN = /\{\{([^}]+)\}\}/g;
const normalize = (label)=>label.trim().toLowerCase();
export function resolveSegments(text, apiVariables, customVariables) {
    if (!text) return [];
    const customByLabel = new Map(customVariables.map((entry)=>[
            normalize(entry.label),
            entry.defaultValue
        ]));
    const apiByLabel = new Map(Object.entries(apiVariables).map((param)=>{
        let [label, value] = param;
        return [
            normalize(label),
            value
        ];
    }));
    const segments = [];
    let lastIndex = 0;
    for (const match of text.matchAll(TAG_PATTERN)){
        var _match_index;
        const label = match[1].trim();
        const start = (_match_index = match.index) !== null && _match_index !== void 0 ? _match_index : 0;
        if (start > lastIndex) {
            segments.push({
                kind: 'text',
                value: text.slice(lastIndex, start)
            });
        }
        const apiValue = apiByLabel.get(normalize(label));
        if (apiValue != null) {
            segments.push({
                kind: 'text',
                value: apiValue
            });
        } else {
            const customValue = customByLabel.get(normalize(label));
            if (customValue != null && customValue !== '') {
                segments.push({
                    kind: 'text',
                    value: customValue
                });
            } else {
                segments.push({
                    kind: 'unresolved',
                    label
                });
            }
        }
        lastIndex = start + match[0].length;
    }
    if (lastIndex < text.length) {
        segments.push({
            kind: 'text',
            value: text.slice(lastIndex)
        });
    }
    return segments;
}
const INVOICE_NOTIFICATIONS = new Set([
    'invoiceIssuedAutoProcess',
    'invoiceIssuedRequiresApproval',
    'adHocInvoiceIssued',
    'adHocInvoiceOverdueReminderCustomer',
    'adHocInvoiceOverdueReminderVendor',
    'invoiceRefundedCustomer',
    'invoiceRefundedVendor',
    'invoiceRefundFailedVendor',
    'paymentFailedCustomer',
    'paymentFailedVendor'
]);
const PAYOUT_NOTIFICATIONS = new Set([
    'payoutDepositedVendor',
    'payoutFailedVendor'
]);
export function pickSkeleton(notificationName) {
    if (INVOICE_NOTIFICATIONS.has(notificationName)) return 'invoice';
    if (PAYOUT_NOTIFICATIONS.has(notificationName)) return 'payout';
    return null;
}
